// extracted by mini-css-extract-plugin
export default {"linkButton":"index_linkButton__X+PXM","notlink":"index_notlink__4BjWj","applying":"index_applying__J-N0+","linking":"index_linking__QPwD5"};